// extracted by mini-css-extract-plugin
export var active = "PrivacyTabs-module--active--tbNkj";
export var noBackground = "PrivacyTabs-module--noBackground--Y4xrX";
export var privacyTabs = "PrivacyTabs-module--privacyTabs--nr05o";
export var tabButton = "PrivacyTabs-module--tabButton--d-ODK";
export var tabButtons = "PrivacyTabs-module--tabButtons--28uV3";
export var tabContent = "PrivacyTabs-module--tabContent--NYllv";
export var tabContents = "PrivacyTabs-module--tabContents--3gLFw";
export var textBlock = "PrivacyTabs-module--textBlock--G77wb";
export var wrapper = "PrivacyTabs-module--wrapper--3nmfE";